import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TopicWorkloadProtectionIcon extends BaseIcon {
  getChildren = () => [
    <g fill={ this.getColor() }>
      <path d="M13 1.2L1.2 5.9l3.1 15.8 8.7 3.1 8.7-3.1 3.1-15.8L13 1.2zM20 20l-7 2.5L6 20 3.5 7.3 13 3.5l9.5 3.8L20 20z"/>
      <path d="M16.8 11.5l-4.4 4.4c-.1.1-.4.3-.6.3-.1 0-.4-.1-.7-.3l-1.9-2.1c-.3-.3-.3-1 0-1.3s.9-.3 1.3 0l1.3 1.3 3.7-3.8c.3-.3.9-.3 1.3 0 .3.5.3 1 0 1.5z"/>
      <g>
        <path d="M50.6 24.8H35.5c-.9 0-1.7-.8-1.7-1.7V2.9h5c0-.9.8-1.7 1.7-1.7h5c.9 0 1.7.8 1.7 1.7h5v20.2c.1.9-.6 1.7-1.6 1.7zM35.5 6.3v16.8h15.1V6.3H35.5zm1.7 13.4V18H49v1.7H37.2zm0-5H49v1.7H37.2v-1.7zm0-3.4H49V13H37.2v-1.7z"/>
      </g>
    </g>
  ]
  getViewBox = () => '0 0 26 26'
}
